/** Defaults aligned with marketing solution demo (`solution-demo/index.tsx`). */
export const SOLUTION_DEMO_PATH_RANGE = {
	yMinRange: -4,
	yMaxRange: 1,
	xMaxStepsBack: 1,
	xMaxStepsForward: 5,
} as const;

export const DEFAULT_PATH_GENERATION_MAX_ATTEMPTS = 50;
export const DEFAULT_MAX_CONSECUTIVE_SAME_DIRECTION_STEPS = 3;

export interface PathGeneratorConfig {
	startRow: number;
	startCol: number;
	endRow: number;
	endCol: number;
	endRowMin?: number;
	endRowMax?: number;
	yMinRange: number;
	yMaxRange: number;
	minCol?: number;
	maxCol?: number;
	xMaxStepsBack?: number;
	xMaxStepsForward?: number;
	maxConsecutiveSameDirectionSteps?: number;
}

export interface PathGenerationAttemptOptions {
	seed: string;
	targetLength: number;
	config: PathGeneratorConfig;
	maxAttempts?: number;
	/** Log attempt numbers to console (testing). */
	logAttempts?: boolean;
}

export interface PathGenerationResult {
	path: import("./types").HexCoord[];
	attempt: number;
}
